import React from 'react';

import './style.css';

import PortalResourcePreviewBox from './PortalResourcePreviewBox';
import FAQPreviewBox  from './FAQPreviewBox';

const PreviewBox = ({element: element, i: i, shouldCenter: shouldCenter, shouldMaxHeight: shouldMaxHeight, showDate: showDate}) => {
    
	if (element.isVideoFAQItem) {
        return (
            <FAQPreviewBox element={element} i={i} shouldCenter={shouldCenter} shouldMaxHeight={shouldMaxHeight} showData={showDate}/>
        );
    }
	else {
		return <PortalResourcePreviewBox element={element} i={i} shouldCenter={shouldCenter} shouldMaxHeight={shouldMaxHeight} showData={showDate}/>
	}
};

export default PreviewBox;
